import { render, staticRenderFns } from "./SelectStaffPosition.vue?vue&type=template&id=7a52a3c0&"
import script from "./SelectStaffPosition.vue?vue&type=script&lang=js&"
export * from "./SelectStaffPosition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports